<template>
  <div class="footer-wrapper">
    <!-- Footer  -->
    <footer>
      <template>
        <!-- NewsletterSuccess modal (only on Desktop, no Newsletter Signup in Mobile View) -->
        <v-dialog
          v-if="$vuetify.breakpoint.mdAndUp"
          v-model="mailInputSuccessModal"
          width="777px"
          content-class="mail-input-success-modal"
          scrollable
        >
          <v-card class="dialog-card">
            <v-card-text>
              <div class="body">
                <img
                  class="quote-top"
                  alt="anni logo"
                  src="../../assets/quotes.svg"
                />

                <div class="text-semibold">
                  {{ mailInputSuccessModalText }}
                </div>

                <img
                  class="quote-bottom"
                  alt="anni logo"
                  src="../../assets/quotes.svg"
                />
              </div>

              <v-card-actions>
                <v-btn
                  color="primary"
                  class="primary-txt-btn"
                  text
                  @click="mailInputSuccessModal = false"
                >
                  Schließen
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- NewsletterSuccess BottomSheet (Mobile) -->
        <v-bottom-sheet
          v-if="$vuetify.breakpoint.smAndDown"
          v-model="mailInputSuccessModal"
          content-class="bottom-sheet"
          inset
        >
          <v-sheet v-model="mailInputSuccessModal" class="text-center">
            <div class="body">
              <!-- <img class="quote-top" width="35" alt="anni logo" src="../../assets/quotes.svg" /> -->
              <div class="text-semibold">{{ mailInputSuccessModalText }}</div>
              <!-- <img width="35" class="quote-bottom" alt="anni logo" src="../../assets/quotes.svg" /> -->
            </div>

            <v-card-actions>
              <v-btn
                color="primary"
                class="primary-txt-btn"
                @click="mailInputSuccessModal = false"
                text
              >
                Schließen
              </v-btn>
            </v-card-actions>
          </v-sheet>
        </v-bottom-sheet>

        <v-container class="py-0 catalogue-container">
          <section class="footer-upper px-0">
            <section class="footer-description">
              <div class="f-logo">
                <img
                  alt="anni.care Logo"
                  src="../../assets/anni.careBrandLogo.svg"
                  :width="195"
                  :height="33.58"
                />
              </div>

              <div class="f-desc text-center">
                Mit Automatisierung Zukunft schaffen.
              </div>

              <div class="social-media">
                <a
                  class="ml-2"
                  v-for="(fms, index) in footerSocialMedia"
                  :key="index"
                  :href="fms.link"
                >
                  <img :src="fms.logo" alt />
                </a>
              </div>
            </section>

            <section class="f-contact" v-if="$vuetify.breakpoint.smAndDown">
              <div class="sm-email-description">
                Sie möchten nichts mehr verpassen?
              </div>

              <div class="sm-email-title">Newsletter abonnieren</div>

              <v-text-field
                label="E-Mail Adresse eingeben"
                class="mt-6 sm-news-letter"
                id="email-input"
                flat
                height="37"
                solo
                required
                v-model="mailInput"
                :rules="validationRules"
                autocomplete="email"
              />

              <button
                type="submit"
                class="nl-button"
                @click="addNewContactToNewsletter()"
                :disabled="!isEmailValid"
              >
                Jetzt anmelden
              </button>
            </section>

            <div class="f-info">
              <section class="f-links">
                <div class="title">Angebot</div>
                <div class="text-small">
                  <div v-for="(link, i) in links" :key="i">
                    <a :href="link.link" :target="link.target">
                      {{ link.title }}
                    </a>
                  </div>
                </div>
              </section>

              <section class="f-legal">
                <div class="title">Sonstiges</div>
                <div class="text-small">
                  <div v-for="(legal, i) in legals" :key="i">
                    <a :href="legal.link" :target="legal.target">{{
                      legal.title
                    }}</a>
                  </div>
                </div>
              </section>

              <section class="f-contact" v-if="$vuetify.breakpoint.mdAndUp">
                <div class="email-description">
                  Sie möchten, dass ANNI Sie immer auf dem neuesten Stand hält?
                  Dann melden Sie sich jetzt für unseren Newsletter an!
                </div>

                <v-text-field
                  label="E-Mail Adresse eingeben"
                  class="mt-6 news-letter"
                  id="email-input"
                  flat
                  height="35"
                  solo
                  v-model="mailInput"
                  :rules="validationRules"
                  autocomplete="email"
                />

                <button
                  type="submit"
                  class="nl-button"
                  @click="addNewContactToNewsletter()"
                  :disabled="!isEmailValid"
                >
                  Jetzt anmelden
                </button>
              </section>
            </div>

            <v-carousel
              v-if="$vuetify.breakpoint.smAndDown"
              hide-delimiters
              :show-arrows="false"
              interval="3000"
              cycle
            >
              <v-carousel-item v-for="partner in partners" :key="partner">
                <img :src="partner" alt />
              </v-carousel-item>
            </v-carousel>
          </section>

          <section class="f-partners my-12" v-if="$vuetify.breakpoint.mdAndUp">
            <div v-for="partner in partners" :key="partner" class="fp-logo">
              <img :src="partner" alt />
            </div>
          </section>
        </v-container>
      </template>

      <div class="copyrightarea">
        <span class="footer-copyright-text">
          © anni.care - eine Marke der Healthbytes GmbH. {{ currentYear }}. Alle
          Rechte vorbehalten.
        </span>
      </div>
    </footer>
  </div>
</template>

<script>
import Bs from "../../assets/partnerLogos/Berliner_Senatsverwaltung_mobileFooter.webp";
import Es from "../../assets/partnerLogos/EU Logo quer.svg";
import Mi from "../../assets/partnerLogos/Startup Verband.svg";
import MsS from "../../assets/partnerLogos/MS_Startups_Celebration_Badge_Dark.webp";
import facebook from "../../assets/socialMedia/Facebook_black.svg";
import instagram from "../../assets/socialMedia/Instagram_black.svg";
import linkedin from "../../assets/socialMedia/Group 33696.svg";
import {
  getInfoFromBackend,
  addMailToNewsletter,
} from "../../services/MainService.js";
import { mapActions } from "vuex";
import UI_CONSTANTS from "../../../uiConstants";
import { isValidMail } from "../../services/ValidationService";
import { buildUrlWithSource } from "../../services/route-helpers.js";

export default {
  props: {},

  data() {
    return {
      mailInput: "",
      mailInputSuccessModal: false,
      mailInputSuccessModalText: "",
      links: [
        {
          title: "anni.care connect",
          link: "https://connect.anni.care",
          target: "_blank",
        },
        {
          title: "Rezept Express",
          link: "/rezept-express",
          target: "_self",
        },
        {
          title: "Für Patienten",
          link: "/patienten",
          target: "_self",
        },
        {
          title: "Unsere Partner",
          link: "/unsere-partner",
          target: "_self",
        },
        {
          title: "Partner nach Bundesland",
          link: "/uebersicht",
          target: "_self",
        },
      ],
      legals: [
        {
          title: "Kontakt",
          link: buildUrlWithSource("/kontakt"),
          target: "_self",
        },
        {
          title: "Presse",
          link: buildUrlWithSource("/presse"),
          target: "_self",
        },
        {
          title: "Datenschutz",
          link: buildUrlWithSource("/datenschutz"),
          target: "_self",
        },
        {
          title: "Impressum",
          link: buildUrlWithSource("/impressum"),
          target: "_self",
        },
      ],
      partners: [Bs, Es, Mi, MsS],
      validationRules: [
        (input) => isValidMail(input) || UI_CONSTANTS.wrongEmail,
      ],
      footerSocialMedia: [
        {
          logo: facebook,
          link: "https://www.facebook.com/annihilfsmittel",
        },
        {
          logo: instagram,
          link: "https://www.instagram.com/annihilfsmittel/",
        },
        {
          logo: linkedin,
          link: "https://www.linkedin.com/company/anni-care",
        },
      ],
      backendVersion: "",
      currentYear: new Date().getFullYear(),
    };
  },

  computed: {
    isEmailValid() {
      return isValidMail(this.mailInput);
    },
  },

  methods: {
    ...mapActions(["recordInteraction"]),
    //Load info from backend and update current backend version in Footer.
    async loadInfoFromBackend() {
      let backendInfo = await getInfoFromBackend();
      this.backendVersion = backendInfo["version"];
      console.log(this.backendVersion);
    },
    async addNewContactToNewsletter() {
      this.recordInteraction({
        eventType: "newNewsletterRegistration",
        eventData: {
          source: "Footer",
        },
      });
      let returnValue = await addMailToNewsletter(this.mailInput, "Newsletter");
      if (returnValue.success) {
        this.mailInputSuccessModalText =
          "Vielen Dank für Ihre Anmeldung! Damit Sie regelmäßig Neuigkeiten von uns erhalten, müssen Sie noch Ihr Abonnement bestätigen. Sie finden nähere Informationen dazu in Ihrem Postfach.";
        this.mailInputSuccessModal = true;
        this.mailInput = "";
      } else {
        this.mailInputSuccessModalText =
          "Leider gab es ein Problem bei der Bestellung des Newsletter. Versuchen Sie es später erneut oder kontaktieren Sie unseren Administrator unter info@anni.care.";
        this.mailInputSuccessModal = true;
        this.mailInput = "";
      }
    },
  },

  mounted() {
    //Load Version from Backend
    this.loadInfoFromBackend();
  },
};
</script>

<style lang="scss">
:root {
  --color-brand: #35887e;
  --color-hover-brand: #225952;
}

.footer-wrapper {
  font-family: Poppins, sans-serif;
}

.nl-button {
  display: flex;
  padding: 0.75rem 1.5rem;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  font-size: 14px;
  line-height: 134%;
  font-weight: 600;
  border: none;
  text-decoration: none;
  transition: background-color 0.1s ease-in-out, max-width 0.2s ease-in-out;
  text-align: center;
  cursor: pointer;
  background-color: var(--color-brand);
  color: #fff;
  width: 100%;
  max-width: 360px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -30px;

  @media (hover: hover) {
    &:hover:not(:disabled) {
      background-color: var(--color-hover-brand);
    }
  }

  &:focus-visible {
    outline: 3px solid;
    outline-offset: 3px;
    outline-color: var(--color-brand);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>
